export const TZ = "Europe/Rome";

export const formatPrice = (cents, locale = "it-IT") =>
  new Intl.NumberFormat(locale, { style: "currency", currency: "EUR", minimumFractionDigits: cents % 100 === 0 ? 0 : 2 }).format((cents || 0) / 100);

export const formatEur = (cents, locale = "it-IT") =>
  new Intl.NumberFormat(locale, { style: "currency", currency: "EUR", minimumFractionDigits: 2 }).format((cents || 0) / 100);

export const formatDate = (iso, locale = "it-IT", withTime = false) => {
  if (!iso) return "—";
  const opts = { timeZone: TZ, day: "2-digit", month: "short", year: "numeric" };
  if (withTime) Object.assign(opts, { hour: "2-digit", minute: "2-digit" });
  return new Intl.DateTimeFormat(locale, opts).format(new Date(iso));
};

export const formatKm = (m) => (m == null ? null : m < 1000 ? "< 1 km" : `${Math.round(m / 1000)} km`);

export const formatCoins = (n, locale = "it-IT") => new Intl.NumberFormat(locale).format(n || 0);
